export default __webpack_public_path__ + "static/media/246.a1be299c.gif";